import { Button, Stack, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import axios from 'axios';
import { useGetRequestUrl } from '../hooks/useGetRequestUrl';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
export default function Compose({ token, setToken }) {
  const navigate = useNavigate();
  const requestUrl = useGetRequestUrl();
  const [cookies, _] = useCookies(['access_token']);
  const [recipe, setRecipe] = useState({
    title: '',
    description: '',
    instructions: '',
    ingredients: [],
    imageUrl: '',
    timeToCook: null,
  });

  const handleChange = (event) => {
    const { value, name } = event.target;
    setRecipe({ ...recipe, [name]: value });
  };
  const handleIngredientChange = (event, index) => {
    const { value } = event.target;
    const ingredients = [...recipe.ingredients];
    ingredients[index] = value;
    setRecipe({ ...recipe, ingredients: ingredients });
  };
  const addIngredientHandler = () => {
    const ingredients = [...recipe.ingredients, ''];
    setRecipe({ ...recipe, ingredients: ingredients });
  };

  const handleSubmit = async () => {
    const response = await axios.post(
      `${requestUrl}/recipe/compose`,
      {
        title: recipe.title,
        description: recipe.description,
        instructions: recipe.instructions,
        ingredients: [...recipe.ingredients],
        imageUrl: recipe.imageUrl,
        timeToCook: recipe.timeToCook,
      },
      {
        headers: { authorization: `Bearer ${cookies.access_token}` },
      },
      { withCredentials: false }
    );

    console.log(response.data);
    navigate('/');
  };

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      mt="50px"
      gap={2}
      spacing={1}
      mb="50px"
    >
      <Typography fontWeight="700" fontSize="30px">
        Create Recipe
      </Typography>
      <TextField
        variant="outlined"
        placeholder="Title"
        name="title"
        value={recipe.title}
        onChange={(e) => {
          handleChange(e);
        }}
      />
      <TextField
        variant="outlined"
        placeholder="Description"
        name="description"
        value={recipe.description}
        onChange={(e) => {
          handleChange(e);
        }}
      />
      <TextField
        variant="outlined"
        placeholder="Instructions"
        name="instructions"
        value={recipe.instructions}
        onChange={(e) => {
          handleChange(e);
        }}
      />

      <Stack direction="column" gap={2}>
        <Button
          onClick={addIngredientHandler}
          variant="contained"
          color="primary"
        >
          Add Ingredients
        </Button>
        {recipe.ingredients.map((ingredient, index) => {
          return (
            <TextField
              key={index}
              variant="outlined"
              placeholder="Ingredients"
              name=""
              value={ingredient}
              onChange={(e) => {
                handleIngredientChange(e, index);
              }}
            />
          );
        })}
      </Stack>

      <TextField
        variant="outlined"
        placeholder="Image URL"
        name="imageUrl"
        value={recipe.imageUrlrl}
        onChange={(e) => {
          handleChange(e);
        }}
      />
      <TextField
        variant="outlined"
        placeholder="Time take to cook"
        name="timeToCook"
        value={recipe.timeToCook}
        onChange={(e) => {
          handleChange(e);
        }}
      />
      <Button onClick={handleSubmit} variant="contained" color="success">
        Compose
      </Button>
    </Stack>
  );
}
